import React, { useEffect, useState } from "react";
import axios from "axios";

function Settings() {

  const user = JSON.parse(localStorage.getItem("user"));

  const [profile, setProfile] = useState({
    name: "",
    email: "",
  });

  const [password, setPassword] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (user) {
      setProfile({
        name: user.name,
        email: user.email,
      });
    }
  }, []);

  // Update Profile
  const updateProfile = async (e) => {

    e.preventDefault();

    try {
	//const token = localStorage.getItem("token");
      const response = await axios.put(
        "http://localhost:5000/api/profile",
        profile,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert(response.data.message);

      localStorage.setItem(
        "user",
        JSON.stringify({
          ...user,
          name: profile.name,
          email: profile.email,
        })
      );

    } catch (error) {

      alert(
        error.response?.data?.message ||
        "Something went wrong."
      );

    }

  };

  // Change Password
  const changePassword = async (e) => {

    e.preventDefault();

    if (password.newPassword !== password.confirmPassword) {
      alert("Passwords do not match.");
      return;
    }

    try {

      const response = await axios.put(
        "http://localhost:5000/api/change-password",
        {
          currentPassword: password.currentPassword,
          newPassword: password.newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert(response.data.message);

      setPassword({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });

    } catch (error) {

      alert(
        error.response?.data?.message ||
        "Something went wrong."
      );

    }

  };

  return (
    <div className="container-fluid py-4">

      <div className="row">

        {/* Profile */}

        <div className="col-lg-6 mb-4">

          <div className="card shadow">

            <div className="card-header bg-primary text-white">
              <h5 className="mb-0">
                Update Profile
              </h5>
            </div>

            <div className="card-body">

              <form onSubmit={updateProfile}>

                <div className="mb-3">

                  <label className="form-label">
                    Full Name
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    value={profile.name}
                    onChange={(e) =>
                      setProfile({
                        ...profile,
                        name: e.target.value,
                      })
                    }
                    required
                  />

                </div>

                <div className="mb-3">

                  <label className="form-label">
                    Email Address
                  </label>

                  <input
                    type="email"
                    className="form-control"
                    value={profile.email}
                    onChange={(e) =>
                      setProfile({
                        ...profile,
                        email: e.target.value,
                      })
                    }
                    required
                  />

                </div>

                <button className="btn btn-primary">
                  Update Profile
                </button>

              </form>

            </div>

          </div>

        </div>

        {/* Password */}

        <div className="col-lg-6">

          <div className="card shadow">

            <div className="card-header bg-danger text-white">
              <h5 className="mb-0">
                Change Password
              </h5>
            </div>

            <div className="card-body">

              <form onSubmit={changePassword}>

                <div className="mb-3">

                  <label className="form-label">
                    Current Password
                  </label>

                  <input
                    type="password"
                    className="form-control"
                    value={password.currentPassword}
                    onChange={(e) =>
                      setPassword({
                        ...password,
                        currentPassword: e.target.value,
                      })
                    }
                    required
                  />

                </div>

                <div className="mb-3">

                  <label className="form-label">
                    New Password
                  </label>

                  <input
                    type="password"
                    className="form-control"
                    value={password.newPassword}
                    onChange={(e) =>
                      setPassword({
                        ...password,
                        newPassword: e.target.value,
                      })
                    }
                    required
                  />

                </div>

                <div className="mb-3">

                  <label className="form-label">
                    Confirm Password
                  </label>

                  <input
                    type="password"
                    className="form-control"
                    value={password.confirmPassword}
                    onChange={(e) =>
                      setPassword({
                        ...password,
                        confirmPassword: e.target.value,
                      })
                    }
                    required
                  />

                </div>

                <button className="btn btn-danger">
                  Change Password
                </button>

              </form>

            </div>

          </div>

        </div>

      </div>

    </div>
  );
}

export default Settings;